module.exports = __webpack_public_path__ + "static/media/symptoms-vitals-and-lifestyle-tracking-01.81d649c4.png";